import { useContext } from 'react';
import { UserContext } from 'common/context/user/user.context';

export const useUserContext = () => useContext(UserContext);
